import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  font-family: "Roboto", sans-serif;
  background: #121212;
  color: #fff;
  min-height: 100vh;
  padding: 50px 20px;
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  background: #1e1e2f;
  padding: 40px;
  border-radius: 20px;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 20px;
  color: #00d4ff;
`;

const Section = styled.div`
  margin-bottom: 25px;
`;

const SectionTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 10px;
  color: #00bcd4;
`;

const Text = styled.p`
  line-height: 1.7;
  font-size: 1rem;
`;

const RefundPolicy = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <Title>Refund Policy</Title>

        <Section>
          <SectionTitle>1. No Refund Policy</SectionTitle>
          <Text>
            All purchases made on our platform, including online courses, code
            snippets, and other digital technology products, are final and
            non-refundable. Once a product is purchased and access is granted,
            we cannot provide any refunds or exchanges.
          </Text>
        </Section>

        <Section>
          <SectionTitle>2. Digital Nature of Products</SectionTitle>
          <Text>
            As our offerings are digital and accessible immediately upon
            purchase, we cannot accommodate refund requests due to the instant
            availability and usability of the content.
          </Text>
        </Section>

        <Section>
          <SectionTitle>3. Exceptions</SectionTitle>
          <Text>
            Refunds will only be considered if a duplicate payment is made due
            to technical error. In such cases, the extra amount will be credited
            to the original payment method used (via PhonePe or other applicable
            gateway) within 7–10 business days.
          </Text>
          yarn
        </Section>

        <Section>
          <SectionTitle>4. Contact</SectionTitle>
          <Text>
            If you experience any issues with your purchase, please contact us
            at <strong>contact@engineercodewala.in</strong> with your order ID
            and transaction details. While refunds are not offered, we will make
            every effort to resolve your concerns.
          </Text>
        </Section>
      </ContentWrapper>
    </PageContainer>
  );
};

export default RefundPolicy;
